import {FontStyleConfig} from "../../../config/FontConfig";
import {TheRave} from "../../../TheRave";

export class WaysWonTextContainer extends PIXI.Container {

    private readonly _wayWonTextures:string[] = [TheRave.apiPlugin.translations.translate("Way Won"), TheRave.apiPlugin.translations.translate("Ways Won")];

    private _waysWonNumber:PIXI.Text;
    private _waysWonText:PIXI.Text;
    private readonly waysStyle:PIXI.TextStyle = FontStyleConfig.WAYS_WON;

    constructor() {
        super();

        this._waysWonText = new PIXI.Text("", this.waysStyle);
        // this._wayWonTexts.forEach((text:string) => {
        //     this._waysWonText.addSprites({
        //         name : text,
        //         textures : TheRave.assetLoader.getTextures(`initialwin/ways/${text}`),
        //         anchor : new PIXI.Point(1, 0.5)
        //     });
        // });
        this._waysWonText.anchor.set(1, 0.5);
        this._waysWonText.position.set(0, 0);
        this.addChild(this._waysWonText);

        this._waysWonNumber = new PIXI.Text("", this.waysStyle);
        this._waysWonNumber.anchor.set(0, 0.5);
        this.addChild(this._waysWonNumber);
    }

    public show(winWaysWon:number):void {
        this._waysWonNumber.text = "" + winWaysWon;
        const textureName:string = winWaysWon === 1 ? this._wayWonTextures[0] : this._wayWonTextures[1];
        this._waysWonText.text = textureName;
        this.updatePositions();
    }

    private updatePositions():void {
        const space = 10;
        this._waysWonNumber.updateTransform();
        const totalWidth:number = this._waysWonNumber.width + this._waysWonText.width + space;
        this._waysWonNumber.x = -totalWidth / 2;
        this._waysWonText.x = totalWidth / 2;
    }

    public setColor(color:number):void {
        this._waysWonNumber.tint = color;
        this._waysWonText.tint = color;
    }
}